import { render, staticRenderFns } from "./RegulatoryInfoProductTypesTab.vue?vue&type=template&id=01b219f5&"
import script from "./RegulatoryInfoProductTypesTab.vue?vue&type=script&lang=js&"
export * from "./RegulatoryInfoProductTypesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports